module.exports = __webpack_public_path__ + "img/front.2f73e328.png";